import { render, staticRenderFns } from "./son1.vue?vue&type=template&id=5a47f83a&"
import script from "./son1.vue?vue&type=script&lang=js&"
export * from "./son1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports